import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-backtesting',
  templateUrl: './backtesting.component.html',
  styleUrls: ['./backtesting.component.css']
})
export class BacktestingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
